import { PropsWithChildren } from "react";
import { ProgressBar } from "react-migration/components/ProgressBar";

export interface FooterProps extends PropsWithChildren {
  percentage?: number;
  dataTestId?: string;
}

export const Footer = ({ percentage = 0, dataTestId, children }: FooterProps) => {
  return (
    <div data-testid={dataTestId ?? "letters-footer"} className="sticky top-[100vh]">
      <ProgressBar percentage={percentage} />
      <div className="w-full bg-background-surface px-6 flex flex-row my-2.5">{children}</div>
    </div>
  );
};
